import React, { Component, Fragment } from 'react';
import { Flex, Toast, PullToRefresh, Modal } from 'antd-mobile';
import { PriceText, CardOpenTip } from 'widget';
import _ from 'lodash';
import { ImgWrap } from 'pubBiz';
import Util from 'utils';
import Stores from 'config/Stores';
import config from 'config/Config';

export default function ToWeapp({ jumpType, visible, onClose, usernameStr, recommenderUrl }) {
  // jumpType  // 1: 跳转链商带token  2: 跳转链商推客  3: 跳转链商达人
  const { token } = Stores.AppMod;
  if (!visible || !token) {
    return null;
  }
  const modal_mini_image =
    'https://bucket-prod.obs.cn-east-2.myhuaweicloud.com/images/common/link_to_recommender.png';
  const isProd = config.HOST === 'PROD';
  let path = recommenderUrl || `/pages/Launch/index?token=${token}`;
  if (jumpType === 2) {
    path = `/pages/HomeScreen/index?token=${token}&jumpType=tuike`;
  } else if (jumpType === 3) {
    path = `/pages/HomeScreen/index?token=${token}&jumpType=daren`;
  }
  return (
    <Modal
      title=""
      wrapClassName="posterModal"
      transparent
      visible={visible}
      maskClosable
      onClose={() => onClose()}>
      <div className="weappModal">
        <div>
          <wx-open-launch-weapp
            id="launch-btn"
            username={usernameStr}
            path={path}
            env-version={isProd ? 'release' : 'trial'}>
            <script type="text/wxtag-template">
              <img src={modal_mini_image} style={{ width: '540px', height: 'auto' }} />
            </script>
          </wx-open-launch-weapp>
        </div>
        <img
          style={{ width: '65px', marginTop: '58px' }}
          src={`${CDN_BASE}/assets/imgs/learn/icon_close.png`}
          onClick={() => onClose()}
        />
      </div>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/ToRecommenderWeapp/index.js